import Hero from '../../components/Hero';
import NavigationBar from '../../components/NavigationBar';
import Footer from '../../components/Footer';
import Partners from '../../components/Partners';
import CookieBanner from '../../components/CookieBaner';
import Cruises from '../../components/Content/Cruises';
import PriceTable from '../../components/Content/PriceTable';
import Gallery from '../../components/Gallery';
import { cruiseImages } from "../../components/Content/Cruises/images/cruiseImages";
import { Container } from '../../components/Content/styled';
import CruiseHero480 from "./images/cruiseHero480p.webp";
import CruiseHero768 from "./images/cruiseHero768p.webp";
import CruiseHero1080 from "./images/cruiseHero1080p.webp";
import CruiseHero1440 from "./images/cruiseHero1440p.webp";
import GoogleMap from '../../components/Content/GoogleMap';
import Address from '../../components/Content/Address';

function CruisePage() {
    return (
        <>
            <NavigationBar variant="cruises" />
            <main>
                <Hero variant="cruises" images={{
                    480: CruiseHero480,
                    768: CruiseHero768,
                    1080: CruiseHero1080,
                    1440: CruiseHero1440,
                }} />
                <Container>
                    <Cruises />
                    <PriceTable variant="cruises" />
                    <Address variant="cruises" />
                    <GoogleMap variant="cruises" />
                </Container>
                <Gallery images={cruiseImages} variant="cruises" />
                <Partners />
            </main>
            <Footer />
            <CookieBanner />
        </>
    );
}
export default CruisePage;